import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import DashboardCarousel from "./DashboardCarousel";
import ContactSalesModal from "./ContactSalesModal";
import { BillingAPI } from "@/api/billing";

const dashboardImages = [
  "/images/landing-1.png",
  "/images/landing-2.png",
  "/images/landing-3.png",
];

const Hero = () => {
  const [demoOpen, setDemoOpen] = useState(false);

  return (
    <section className="relative z-10 px-6 pb-24 pt-32">
      <div className="container mx-auto">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
          <div className="text-center lg:text-left">
            <h1 className="text-4xl leading-[1.15] tracking-[-0.01em] md:text-5xl lg:text-[3.5rem]">
              <span className="font-bold text-foreground">Multi-Dimensional</span>
              <br />
              <span className="bg-gradient-to-r from-primary to-[hsl(174,45%,45%)] bg-clip-text font-bold text-transparent">
                Open Source Risk
              </span>
              <br />
              <span className="font-bold text-foreground">Visibility</span>
            </h1>

            <p className="mx-auto mt-6 max-w-xl text-[1.05rem] font-light leading-[1.8] text-muted-foreground lg:mx-0">
              See your entire open-source landscape with crystal clarity — from license exposure to
              vulnerability depth, operational health to encryption readiness. One platform, zero blind
              spots.
            </p>

            <div className="mt-8 flex flex-wrap justify-center gap-4 lg:justify-start">
              <Button
                size="lg"
                onClick={() => setDemoOpen(true)}
                className="bg-primary px-8 font-medium text-primary-foreground shadow-[0_0_20px_rgba(15,185,177,0.25)] transition-all duration-300 hover:scale-105 hover:bg-primary/90 hover:shadow-[0_0_30px_rgba(15,185,177,0.4)]"
              >
                Request Demo <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
              <Button
                asChild
                size="lg"
                variant="outline"
                className="border-primary/30 px-8 font-medium text-primary transition-all duration-300 hover:border-primary/50 hover:bg-primary/5"
              >
                <Link to="/signup">
                  Use Community Edition (Free) <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>

            <p className="mt-6 text-sm font-light text-muted-foreground">
              Trusted by engineering, security &amp; legal teams building with open source at scale.
            </p>
          </div>

          <div>
            <DashboardCarousel images={dashboardImages} />
          </div>
        </div>
      </div>

      <ContactSalesModal
        open={demoOpen}
        onOpenChange={setDemoOpen}
        title="Fill in the details for Demo"
        showOrganisation={false}
        confirmOnSuccess
        onSubmit={async (data) => {
          await BillingAPI.publicContactSales({ ...data, source: "demo-request" });
        }}
      />
    </section>
  );
};

export default Hero;
